/**
 * @generated SignedSource<<7774909b94e44b758e6bcf61d951cd9f>>
 * @relayHash dfa04e51a646cfd023e8af5ff319e30e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0bfdc624a6e47e20f82bbb750221d5d10a3e538d9013f6081b973ff3fcff8f60

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useListSubscriptions_issueCreatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type useListSubscriptions_issueCreatedSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useListSubscriptions_issueCreatedSubscription = {
  response: useListSubscriptions_issueCreatedSubscription$data;
  variables: useListSubscriptions_issueCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useListSubscriptions_issueCreatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useListSubscriptions_issueCreatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0bfdc624a6e47e20f82bbb750221d5d10a3e538d9013f6081b973ff3fcff8f60",
    "metadata": {},
    "name": "useListSubscriptions_issueCreatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "068495a33345aa411b7d71217aa48e6b";

export default node;
